export default "__VITE_ASSET__BGW9zUQS__"